// Helper to normalize any date string to YYYY-MM-DD
export const normalizeDateStr = (dateStr) => {
  if (!dateStr) return null;
  const s = String(dateStr).replace(/ 00:00:00/g, '').trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const parts = s.match(/^(\d{1,2})[/\-.](\d{1,2})[/\-.](\d{4})$/);
  if (parts) return `${parts[3]}-${parts[2].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
  return null;
};

// Check if discount has expired (compare date strings to avoid timezone issues)
export const isDiscountExpired = (expiryDate) => {
  if (!expiryDate) return false;
  try {
    const dateStr = normalizeDateStr(expiryDate);
    if (!dateStr) return false;
    const now = new Date();
    const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    return dateStr < todayStr;
  } catch { return false; }
};

// Format discount expiry (parse manually to avoid timezone shift)
export const formatDiscountExpiry = (expiryDate) => {
  if (!expiryDate) return null;
  try {
    const dateStr = normalizeDateStr(expiryDate);
    if (!dateStr) return String(expiryDate);
    const [y, m, d] = dateStr.split('-');
    return `${d}/${m}/${y}`;
  } catch { return null; }
};

// Format acta dates
export const formatActaDate = (fecha) => {
  if (!fecha) return null;
  try {
    const cleaned = fecha.replace(' 00:00:00', '').trim();
    if (cleaned.match(/^\d{4}-\d{2}-\d{2}/)) {
      const [y, m, d] = cleaned.split('-');
      return `${d}/${m}/${y}`;
    }
    return cleaned;
  } catch { return fecha; }
};

export const formatActaTime = (hora) => {
  if (!hora) return null;
  return hora.replace(/:\d{2}$/, '').trim();
};
